import { type ItemContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { getUrl } from "@client/lib/settings";
import { combinedSettingsSelector, getCompositeSettingSelector, TargetSelector } from "@client/selectors";
import { type AppState } from "@client/types";
import Component, { type PortfolioGalleryItemComponentProps } from "./component";
import { makeImageInfoSelector, makeTagsSelector } from "./selectors";

export type PortfolioGalleryItemContainerProps = ItemContainerProps & {
  imageStyle: React.CSSProperties;
  overlayStyle?: React.CSSProperties;
  titleTag: string;
};

const makeMapStateToProps = () => {
  const imageSelector = makeImageInfoSelector(TargetSelector.Entity);
  const tagsSelector = makeTagsSelector();

  const parentContentSettingSelector = getCompositeSettingSelector(TargetSelector.Entity, "content");
  const parentTagsSettingSelector = getCompositeSettingSelector(TargetSelector.Entity, "tags");

  const settingsSelector = combinedSettingsSelector(TargetSelector.Entity, [
    "description",
    "title",
    { name: "url", converter: getUrl, prop: "url" },
    "urlType"
  ]);
  return (state: AppState, props: PortfolioGalleryItemContainerProps): PortfolioGalleryItemComponentProps => {
    const settings = settingsSelector(state, props);

    return {
      ...props,
      className: "wsc_content_item portfolio_item",
      image: imageSelector(state, props),
      preventRedirect: state.isEditMode,
      showContent: !!parentContentSettingSelector(state, { id: props.parentId, source: props.source }),
      showTags: !!parentTagsSettingSelector(state, { id: props.parentId, source: props.source }),
      tags: tagsSelector(state, props),
      ...settings
    };
  };
};

export default connectCustom(makeMapStateToProps)(Component);
